<template>
  <div class="columns is-multiline is-main-content is-marginless is-paddingless"
       v-if="criteresRecherche">
    <div class="column is-12  pdb-0"
    :class="[
      {'hauteur-haut-brief-filtre': errors.length === 0},
      {'hauteur-haut-brief-filtre-errors': errors.length > 0}
    ]">
      <div class="column is-12" v-if="errors.length > 0">
        <error-msg-component :messages="errors"
                             :error="errors.length > 0"
                             :title="'ecranAjoutFaces.rechercheContent.errors.problemOccurred'"
                             :withEmplyFields="true"
                             @close="errors = []"/>
      </div>

      <div class="column is-12 mgt-5px">
        <a @click="toggleCriteresRecherche()">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{$t('ecranAjoutFaces.rechercheContent.recherche')}}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{$t('ecranAjoutFaces.rechercheContent.appliquerRecherche')}}
        </span>
      </div>
    </div>
    <div class="column  overflow-auto"
    :class="[
      {'hauteur-brief-filtre': errors.length === 0},
      {'hauteur-brief-filtre-errors': errors.length > 0}
    ]">
      <div class="columns is-multiline is-12 is-marginless is-paddingless">
        <div class="column is-12 is-marginless">
            <b-field :label="$t('ecranAjoutFaces.rechercheContent.periode')" class="obligatoire">
              <div class="columns is-vcentered" >
                <b-datepicker show-week-number
                  class="column"
                  icon="calendar-today"
                  :editable="true"
                  v-model="criteresRecherche.fromDate"
                  :nearby-selectable-month-days="true">
                </b-datepicker>
                <span class="column is-1">{{$t('ecranAjoutFaces.rechercheContent.au')}}</span>
                <b-datepicker show-week-number
                  class="column"
                  icon="calendar-today"
                  :editable="true"
                  v-model="criteresRecherche.toDate"
                  position="is-bottom-left"
                  :nearby-selectable-month-days="true">
                </b-datepicker>
              </div>
            </b-field>
          </div>
          <div class="column is-12 pdb-0">
            <b-field :label="$t('ecranAjoutFaces.rechercheContent.references')">
              <qd-taginput v-model="criteresRecherche.references" type="is-primary">
              </qd-taginput>
            </b-field>
          </div>
          <div class="column is-12 pdb-0">
            <b-field :label="$t('ecranAjoutFaces.rechercheContent.villes')">
              <ville-tag-input-auto-complete
                :critere-recherche="criteresRecherche"
                table-name="Produit"/>
            </b-field>
          </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('ecranAjoutFaces.rechercheContent.departements')">
            <qd-taginput v-model="criteresRecherche.departements" type="is-primary">
            </qd-taginput>
          </b-field>
        </div>
          <div class="column is-12 pdb-0">
            <b-field :label="$t('ecranAjoutFaces.rechercheContent.materiels')">
              <qd-taginput v-model="criteresRecherche.materiels" type="is-primary">
              </qd-taginput>
            </b-field>
          </div>
          <div class="column is-12 pdb-0">
            <b-field :label="$t('ecranAjoutFaces.rechercheContent.formats')">
              <qd-taginput v-model="criteresRecherche.formats" type="is-primary">
              </qd-taginput>
            </b-field>
          </div>
      </div>
    </div>
    <div class="column is-12 hauteur-bas-brief-filtre border-pied pdt-0">
      <button
        class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="saveCriteresRecherche()">
        {{$t('ecranAjoutFaces.rechercheContent.appliquer')}}
      </button>

      <button
        class="button border-none mgt-10px has-text-icon-more pdl-10px"
        @click="viderCriteresRecherche()">
        {{$t('ecranAjoutFaces.rechercheContent.reinitialiser')}}
      </button>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { CLEAR_BRIEF, SET_BRIEF } from '@/store/modules/produitFace-mutation-type';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import validationCriteresRechercheFace from '@/services/catalogue/ajoutFaceAuReseau/validationCriteresRechercheFace';
import VilleTagInputAutoComplete from '@/components/commun/ville/villeTagInputAutoComplete';

const ProduitFace = createNamespacedHelpers('produitFace');

export default {
  name: 'CatalogueProduitReseauAjoutFacesRecherche',
  data() {
    return {
      criteresRecherche: null,
      errors: [],
    };
  },
  components: {
    errorMsgComponent,
    VilleTagInputAutoComplete,
  },
  computed: {
    ...ProduitFace.mapGetters({
      criteresRechercheStock: 'brief',
    }),
  },
  methods: {
    ...ProduitFace.mapMutations({
      setCriteresRecherche: SET_BRIEF,
      clearCriteresRecherche: CLEAR_BRIEF,
    }),
    viderCriteresRecherche() {
      this.clearCriteresRecherche();
      this.criteresRecherche = cloneDeep(this.criteresRechercheStock);
    },
    saveCriteresRecherche() {
      this.errors = [];
      validationCriteresRechercheFace(this.criteresRecherche, this.errors);
      if (this.errors.length > 0) return;
      this.setCriteresRecherche(this.criteresRecherche);
      this.toggleCriteresRecherche();
      this.$emit('appliquerCriteresRecherche');
    },
    toggleCriteresRecherche() {
      this.$emit('toggleCriteresRecherche');
    },
  },
  mounted() {
    this.criteresRecherche = cloneDeep(this.criteresRechercheStock);
  },
};
</script>
